export default {
    handle(bloodDonorModel) {
        bloodDonorModel.already_association_member = bloodDonorModel.already_association_member === 'yes';

        return true;
    }
}